// @ts-ignore
/* eslint-disable */
import request from './request';

/** 此处后端没有提供注释 GET /api/fnb/public/v1/addressing/communes */
export async function getPublicV1AddressingCommunes(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1AddressingCommunesParams,
  options?: { [key: string]: any }
) {
  return request<API.CommuneModelIReadOnlyListResponse>('/api/fnb/public/v1/addressing/communes', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/addressing/countries */
export async function getPublicV1AddressingCountries(options?: { [key: string]: any }) {
  return request<API.CountryModelIReadOnlyListResponse>('/api/fnb/public/v1/addressing/countries', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/addressing/provinces */
export async function getPublicV1AddressingProvinces(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1AddressingProvincesParams,
  options?: { [key: string]: any }
) {
  return request<API.ProvinceModelIReadOnlyListResponse>(
    '/api/fnb/public/v1/addressing/provinces',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/cart-recoveries */
export async function postPublicV1CartRecoveries(
  body: API.RecoverPublicCartRequest,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/cart-recoveries', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/carts */
export async function postPublicV1Carts(options?: { [key: string]: any }) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/carts', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/carts/${param0} */
export async function getPublicV1CartsCartId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1CartsCartIdParams,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/carts/${param0}/checkout */
export async function postPublicV1CartsCartIdCheckout(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postPublicV1CartsCartIdCheckoutParams,
  body: API.PublicCheckoutRequest,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/checkout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/carts/${param0}/items */
export async function postPublicV1CartsCartIdItems(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postPublicV1CartsCartIdItemsParams,
  body: API.PublicCartItemRequest,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/items`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 PUT /api/fnb/public/v1/carts/${param0}/items/${param1} */
export async function putPublicV1CartsCartIdItemsItemId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putPublicV1CartsCartIdItemsItemIdParams,
  body: API.PublicCartItemRequest,
  options?: { [key: string]: any }
) {
  const { cartId: param0, itemId: param1, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(
    `/api/fnb/public/v1/carts/${param0}/items/${param1}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 DELETE /api/fnb/public/v1/carts/${param0}/items/${param1} */
export async function deletePublicV1CartsCartIdItemsItemId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deletePublicV1CartsCartIdItemsItemIdParams,
  options?: { [key: string]: any }
) {
  const { cartId: param0, itemId: param1, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(
    `/api/fnb/public/v1/carts/${param0}/items/${param1}`,
    {
      method: 'DELETE',
      params: {
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 PUT /api/fnb/public/v1/carts/${param0}/pickup */
export async function putPublicV1CartsCartIdPickup(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putPublicV1CartsCartIdPickupParams,
  body: API.SetPublicPickupRequest,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/pickup`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/carts/${param0}/promotions */
export async function getPublicV1CartsCartIdPromotions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1CartsCartIdPromotionsParams,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/promotions`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 PUT /api/fnb/public/v1/carts/${param0}/promotions */
export async function putPublicV1CartsCartIdPromotions(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putPublicV1CartsCartIdPromotionsParams,
  body: API.SetPublicPromotionsRequest,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/promotions`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 PUT /api/fnb/public/v1/carts/${param0}/voucher */
export async function putPublicV1CartsCartIdVoucher(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.putPublicV1CartsCartIdVoucherParams,
  body: API.ApplyPublicVoucherRequest,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/voucher`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 DELETE /api/fnb/public/v1/carts/${param0}/voucher */
export async function deletePublicV1CartsCartIdVoucher(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deletePublicV1CartsCartIdVoucherParams,
  options?: { [key: string]: any }
) {
  const { cartId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/carts/${param0}/voucher`, {
    method: 'DELETE',
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/events */
export async function getPublicV1Events(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1EventsParams,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/events', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/events/${param0} */
export async function getPublicV1EventsEventId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1EventsEventIdParams,
  options?: { [key: string]: any }
) {
  const { eventId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/events/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/menus */
export async function getPublicV1Menus(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1MenusParams,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/menus', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/menus/${param0}/items */
export async function getPublicV1MenusMenuIdItems(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1MenusMenuIdItemsParams,
  options?: { [key: string]: any }
) {
  const { menuId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/menus/${param0}/items`, {
    method: 'GET',
    params: {
      // page has a default value: 1
      page: '1',
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/moods */
export async function getPublicV1Moods(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1MoodsParams,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/moods', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/moods/${param0}/items */
export async function getPublicV1MoodsMoodCodeItems(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1MoodsMoodCodeItemsParams,
  options?: { [key: string]: any }
) {
  const { moodCode: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/moods/${param0}/items`, {
    method: 'GET',
    params: {
      // limit has a default value: 10
      limit: '10',
      // page has a default value: 1
      page: '1',
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/ordering-sessions */
export async function postPublicV1OrderingSessions(
  body: API.ExchangeQrRequest,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/ordering-sessions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/ordering-sessions/menu */
export async function getPublicV1OrderingSessionsMenu(options?: { [key: string]: any }) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/ordering-sessions/menu', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/ordering-sessions/products/${param0} */
export async function getPublicV1OrderingSessionsProductsProductId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1OrderingSessionsProductsProductIdParams,
  options?: { [key: string]: any }
) {
  const { productId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(
    `/api/fnb/public/v1/ordering-sessions/products/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/ordering-sessions/store */
export async function postPublicV1OrderingSessionsStore(
  body: API.CreateStoreOrderingSessionRequest,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/ordering-sessions/store', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/ordering-sessions/walk-in-customer */
export async function getPublicV1OrderingSessionsWalkInCustomer(options?: { [key: string]: any }) {
  return request<API.PublicFnbResponseResponse>(
    '/api/fnb/public/v1/ordering-sessions/walk-in-customer',
    {
      method: 'GET',
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/orders/${param0}/cancellation */
export async function postPublicV1OrdersOrderCodeCancellation(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postPublicV1OrdersOrderCodeCancellationParams,
  body: API.CancelPublicOrderRequest,
  options?: { [key: string]: any }
) {
  const { orderCode: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(
    `/api/fnb/public/v1/orders/${param0}/cancellation`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 此处后端没有提供注释 POST /api/fnb/public/v1/orders/${param0}/payment */
export async function postPublicV1OrdersOrderCodePayment(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.postPublicV1OrdersOrderCodePaymentParams,
  body: API.InitializePublicPaymentRequest,
  options?: { [key: string]: any }
) {
  const { orderCode: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/orders/${param0}/payment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...queryParams },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/orders/${param0}/tracking */
export async function getPublicV1OrdersOrderCodeTracking(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1OrdersOrderCodeTrackingParams,
  options?: { [key: string]: any }
) {
  const { orderCode: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/orders/${param0}/tracking`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/products/${param0} */
export async function getPublicV1ProductsProductId(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1ProductsProductIdParams,
  options?: { [key: string]: any }
) {
  const { productId: param0, ...queryParams } = params;
  return request<API.PublicFnbResponseResponse>(`/api/fnb/public/v1/products/${param0}`, {
    method: 'GET',
    params: {
      ...queryParams,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/products/best-sellers */
export async function getPublicV1ProductsBestSellers(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1ProductsBestSellersParams,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/products/best-sellers', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/fnb/public/v1/stores */
export async function getPublicV1Stores(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getPublicV1StoresParams,
  options?: { [key: string]: any }
) {
  return request<API.PublicFnbResponseResponse>('/api/fnb/public/v1/stores', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
